// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1VVdh","bigColWidth":"Table_bigColWidth__PBeqG","biggerColWidth":"Table_biggerColWidth__1NKjH","row":"Table_row__BIyvn","col":"Table_col__ogJ-M"};